module.exports = __webpack_public_path__ + "img/logo.13f1c945.svg";